









































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "equipment/main";

  columns: any[] = [
    { title: "片场", dataIndex: "ground_name" },
    { title: "当前状态", scopedSlots: { customRender: "status" } }
  ];

  toggleMainEquip(etype: number, subid: number, ctrl_type: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要${ctrl_type ? "打开" : "关闭"}该设备吗？`,
      onOk: async () => {
        let action = "stadium/toggleSubEquip";

        if (etype === 5) {
          action = "stadium/toggleMainEquip";
        }

        const res = await this.$store.dispatch(action, {
          stadium_id: this.stadiumId,
          ground_id: subid,
          ctrl_type
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData(
            {
              stadium_id: this.stadiumId,
              type: 6
            },
            false
          );
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        type: 6
      },
      false
    );
  }
}
